module.exports = __webpack_public_path__ + "img/journal-whills.590d9bc3.svg";